import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    // Aquí agregaremos las rutas para los submódulos cuando los creemos
    {
        path: 'historialevaluaciones',
        loadChildren: () => import('./modules/historialevaluaciones/historialevaluaciones.module').then(m => m.HistorialevaluacionesModule)
    },
    {
        path: 'crearevaluacion',
        loadChildren: () => import('./modules/crearevaluacion/crearevaluacion.module').then(m => m.CrearevaluacionModule)
    },
    {
        path: 'campanas',
        loadChildren: () => import('./modules/campanas/campanas.module').then(m => m.CampanasModule)
    },
    {
        path: 'periodos',
        loadChildren: () => import('./modules/periodos/periodos.module').then(m => m.PeriodosModule)
    },
    {
        path: 'objetivos',
        loadChildren: () => import('./modules/objetivos/objetivos.module').then(m => m.ObjetivosModule)
    },
    {
        path: 'evaluadores',
        loadChildren: () => import('./modules/evaluadores/evaluadores.module').then(m => m.EvaluadoresModule)
    },
    {
        path: 'metas',
        loadChildren: () => import('./modules/metas/metas.module').then(m => m.MetasModule)
    },
    {
        path: 'ocvreales',
        loadChildren: () => import('./modules/ocvreales/ocvreales.module').then(m => m.OcvRealesModule)
    },
    {
        path: 'campanametas',
        loadChildren: () => import('./modules/campanametas/campanametas.module').then(m => m.CampanametasModule)
    },
    { path: '', redirectTo: 'dashboard', pathMatch: 'prefix' },
    { path: '**', redirectTo: 'dashboard', pathMatch: 'prefix' }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdministradordemonitoreoRoutingModule { }